module.exports = __webpack_public_path__ + "static/media/star-profile.ac5cd8e8.png";